/**
 * Attachments Attachments
 * Wrapper for record attachments that manages
 * operating and displaying attachemnts
 */
import { Box } from '@mui/material';
import React from 'react';
import { defineMessages, useIntl } from 'react-intl';

import FileDropzone from '@components/FileDropzone/FileDropzone';
import InputLabel from '@components/InputLabel';
import { Progress } from '@components/Progress';

import { useFeatureFlags } from '@hooks/useFeatureFlags';
import type { FileManagementProps } from '@hooks/useFileManagement';
import { useFileManagement } from '@hooks/useFileManagement';
import { useSession } from '@hooks/useSession';

import AttachmentList from './AttachmentList';

const messages = defineMessages({
  attachments: {
    id: 'attachments.attachments',
    defaultMessage: 'Attachments',
  },
});

interface AttachmentsProps extends FileManagementProps {
  /** Title override */
  title?: string;
}

const Attachments: React.FC<AttachmentsProps> = ({
  patient_id,
  attachments = [],
  title = '',
  resource,
}) => {
  const { flags } = useFeatureFlags();
  const {
    state: { isClient },
  } = useSession();
  const { handleUpload, progress } = useFileManagement({
    attachments,
    resource,
    patient_id,
  });
  const { formatMessage } = useIntl();

  const canManageAttachments = isClient
    ? false
    : flags.isRecordCreateAttachmentEnabled ||
      flags.isRecordDeleteAttachmentEnabled;

  return (
    <Box>
      <InputLabel
        label={title || formatMessage(messages.attachments)}
        style={{ color: 'primary.main' }}
      />
      <AttachmentList
        attachments={attachments}
        can_delete={canManageAttachments}
        patient_id={patient_id}
        resource={resource}
      />

      {canManageAttachments ? <FileDropzone onUpload={handleUpload} /> : null}
      {typeof progress === 'number' ? (
        <Progress value={progress} width="100%" />
      ) : null}
    </Box>
  );
};

export default Attachments;
